import { render, staticRenderFns } from "./UpsellBoxItem.vue?vue&type=template&id=c76a5232&scoped=true&"
import script from "./UpsellBoxItem.vue?vue&type=script&lang=ts&"
export * from "./UpsellBoxItem.vue?vue&type=script&lang=ts&"
import style0 from "./UpsellBoxItem.vue?vue&type=style&index=0&id=c76a5232&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c76a5232",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c76a5232')) {
      api.createRecord('c76a5232', component.options)
    } else {
      api.reload('c76a5232', component.options)
    }
    module.hot.accept("./UpsellBoxItem.vue?vue&type=template&id=c76a5232&scoped=true&", function () {
      api.rerender('c76a5232', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/UpsellBoxItem.vue"
export default component.exports